<template>
  <div class="Bgc-white">
    <Header/>
    <div class="contentContacto">
                <div class="container contacto">
                    <div class="row justify-content-center">
                        <div class="col-lg-10 col-12 align-items-center position-relative cancelarReserva mb-5">

                            <!-- Datos de estancia -->
                            <b-card-group deck>
                                <b-card header-tag="header" footer-tag="footer">
                                    <p slot="header" class="my-2 text-lg-center text-left row">
                                        <span class="subtitle mb-3 mb-lg-0  col-lg-6 col-12">{{$t('language.posadasCorporate.reservacionesCancelada.text1')}}</span>
                                        <span class="subtitle mb-0 col-lg-6 col-12">{{$t('language.posadasCorporate.reservacionesCancelada.text2')}}: <span class="referencia subtitle">{{numberCancelacion}}</span></span>
                                    </p>

                                    <div>
                                        <p class="estancia mb-4 mt-3"
                                           v-b-toggle.estancia
                                           @click="(iconoActivo == 0) ? iconoActivo = 100 : iconoActivo = 0" >
                                            <i class="icon-building"></i>
                                            {{$t('language.posadasCorporate.reservacionesCancelada.text3')}}
                                            <i class="navi icon-up" :class="(iconoActivo == 0) ? 'oculto' : ''"></i>
                                            <i class="navi icon-navigate-down" :class="(iconoActivo == 0) ? 'camposActive' : 'oculto'" ></i>
                                        </p>
                                    </div>

                                    <b-collapse id="estancia" visible class="row">
                                        <div class="col-12 col-lg-6">
                                            <div>
                                                <img class="d-inline-block mr-3" v-bind:src="hotelMainImage" alt="">
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <div>
                                                <p class="d-inline-block"><b class="subtitle">{{hotelName}}</b></p>
                                                <ul class="listIconModal row">
                                                    <li class="row col-6 d-inline"><p class="col-12 mb-3"><i class="demo-icon icon-check-in pr-2"></i>{{$t('language.posadasCorporate.reservacionesCancelada.text4')}}: 12:00 h</p></li>
                                                    <li class="row col-6 d-inline"><p class="col-12 mb-3"><i class="demo-icon icon-check-out pr-2"></i>{{$t('language.posadasCorporate.reservacionesCancelada.text5')}}: 15:00 h <span id="info" class="icon-info PC-color--colorBase3"></span></p></li>
                                                    <li class="row col-12 d-inline-flex d-lg-flex"><p class="col-12 mb-3"><i class="demo-icon icon-telephone pr-2"></i>{{hotelPhone}}</p></li>
                                                    <li class="row col-12"><p class="col-12 mb-3"><i class="demo-icon icon-location pr-2"></i>{{hotelAddress}}</p>
                                                    <li class="row col-12"><p class="col-12 mb-3 azul cursor"><i class="pr-2"></i><a target="_blank" v-bind:href="srcMaps" style="color: #005a83 !important; text-decoration: none;">{{$t('language.posadasCorporate.reservacionesCancelada.text6')}} </a><i class="demo-icon icon-arrow-right"></i></p></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </b-collapse>

                                </b-card>
                            </b-card-group>


                          <!-- personales -->
                            <b-card-group deck>
                                <b-card header-tag="header" footer-tag="footer">

                                    <div>
                                        <p class="estancia mb-4 mt-3"
                                           v-b-toggle.personales
                                           @click="(iconoActivo == 1) ? iconoActivo = 100 : iconoActivo = 1" >
                                            <i class="icon-user"></i>
                                            {{$t('language.posadasCorporate.reservacionesCancelada.text7')}}
                                            <i class="navi icon-up" :class="(iconoActivo == 1) ? 'oculto' : ''"></i>
                                            <i class="navi icon-navigate-down" :class="(iconoActivo == 1) ? 'camposActive' : 'oculto'" ></i>
                                        </p>
                                    </div>

                                    <b-collapse id="personales" visible class="row">
                                        <div class="col-12 ">
                                            <div class="row">
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text8')}}</p>
                                                    <p class="info">{{nameGuest}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text9')}}</p>
                                                    <p class="info">{{employeeId}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text10')}}</p>
                                                    <p class="info">{{fiestaRewardsNumber}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text11')}}</p>
                                                    <p class="info">{{apreciareClubNumber}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text12')}}</p>
                                                    <p class="info">{{costCenter}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text13')}}</p>
                                                    <p class="info">{{companion===''||companion===null||companion===undefined||companion==='  '?guiones:companion}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                  <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.motiva')}}</p>
                                                  <p class="info">{{(numMotiva===''||numMotiva===null||numMotiva===undefined?guiones:numMotiva)}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </b-collapse>


                                </b-card>
                            </b-card-group>

                          <!-- Reserva -->
                            <b-card-group deck>
                                <b-card header-tag="header" footer-tag="footer">

                                    <div>
                                        <p class="estancia mb-4 mt-3"
                                           v-b-toggle.reserva
                                           @click="(iconoActivo == 2) ? iconoActivo = 100 : iconoActivo = 2" >
                                            <i class="icon-bed"></i>
                                            {{$t('language.posadasCorporate.reservacionesCancelada.text14')}}
                                            <i class="navi icon-up" :class="(iconoActivo == 2) ? 'oculto' : ''"></i>
                                            <i class="navi icon-navigate-down" :class="(iconoActivo == 2) ? 'camposActive' : 'oculto'" ></i>
                                        </p>
                                    </div>

                                    <b-collapse id="reserva" visible class="row">
                                        <div class="col-12 ">
                                            <div class="row">
                                                <div class="col-12">
                                                    <p class="d-inline-block mb-0"><b class="subtitle">{{$t('language.posadasCorporate.reservacionesCancelada.text15')}}</b></p>
                                                </div>
                                                <div class="col-12">
                                                    <p class="parrafoInfo">{{habitaciones}}</p>
                                                    <ul class="listIconModal row">
                                                        <li class="row col-12 col-lg-4">
                                                            <i class="demo-icon icon-calendar col-1"></i>
                                                            <p class="col-10 mb-3 infoHabitacion">{{checkIn}} - {{checkOut}}<br>
                                                            <span class="notasInfoReserva">{{numberOfNights}}</span></p>
                                                        </li>
                                                        <li class="row col-12 col-lg-4">
                                                            <i class="demo-icon icon-bed col-1"></i>
                                                            <p class="col-10 mb-3 infoHabitacion">{{totalRooms}}<br>
                                                            <span class="notasInfoReserva">{{roomContractTypeName}}</span></p>
                                                        </li>
                                                        <li class="row col-12 col-lg-4">
                                                            <i class="demo-icon icon-user col-1"></i>
                                                            <p class="col-10 mb-3 infoHabitacion">{{huespedes}}<br>
                                                              <span class="notasInfoReserva">{{totalAdults}}{{totalChildren}}{{totalInfants}}</span>
                                                            </p>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div class="col-12">
                                                    <p class="d-inline-block mb-0"><b class="subtitle">{{$t('language.posadasCorporate.reservacionesCancelada.text16')}}</b></p>
                                                </div>
                                                <div class="col-12" >
                                                  <iconos v-for="(amenity, index) in amenityList" :key="'amenity_'+index">
                                                    <img :id="'amenity_'+index" :src="amenity.amenityIcon">
                                                  </iconos>

                                                </div>

                                                <p class="col-12" v-if="banConsiEspe || banSuplementMand || banSuplement">
                                                <br>
                                                  <b
                                                    class="subtitle"
                                                  >{{$t('language.posadasCorporate.reservacionConfirmacion.suplementos')}}</b>
                                                </p>
                                                <!-- Mandatory supplements -->

                                                <div  class="col-12">

                          <p v-if="banSuplementMand"
                            class="parrafoInfo"
                          >{{$t('language.posadasCorporate.reservacionConfirmacion.suMan')}}
                        </p>
                         <p v-if="banSuplementMand">
                          <span>{{descriptionMA}}</span>
                        </p>
                                                </div>

                                                <!-- Mandatory supplements-->

                                                <!-- Consideraciones especiales -->
                                                <div  v-if="banConsiEspe" class="col-12">
                                                  <p class="d-inline-block mb-0">
                                                    <b
                                                      class="parrafoInfo"
                                                    >{{$t('language.posadasCorporate.reservacionConfirmacion.consiEspe')}}</b>
                                                  </p>
                                                  <p>
                                                    <span>{{considEspe}}</span>
                                                  </p>
                                                </div>

                                                <!-- OPtional supplements -->

                        <div class="col-12">
                        <p
                          class="parrafoInfo"
                          v-if="banSuplement"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.suplementosIncluidos')}}</p>
                        <p
                          v-if="banSuplement"
                        >{{supleER}}</p>

                      </div>

                                                <!--OPtional supplements -->
                                                <div class="col-12">
                                                    <p class="d-inline-block mb-0"><b class="subtitle">{{$t('language.posadasCorporate.reservacionesCancelada.text17')}}</b></p>
                                                </div>
                                                <div class="col-12">
                                                    <p>
                                                      {{requirementTypeResponse}}
                                                    </p>
                                                </div>

                                                <div class="col-12 row justify-content-lg-end justify-content-start">
                                                    <div class="row col-12 col-lg-6 ">
                                                        <div class="col-6">
                                                            <p class="subtitle mb-0">{{ $t('language.posadasCorporate.generals.totalEstanciaImpuestos') }} {{numberOfNights}}:</p>
                                                        </div>
                                                        <div class="col-6"><br>
                                                            <p class="subtitle mb-0 text-right">$ {{((ls.get('Profile').data.profileId.toLowerCase()=="pyp"||ls.get('Profile').data.profileId.toLowerCase()=="pypsa"||!ls.get('Profile').data.ratesPermissionsResponse.showRates)&&(tabActiveFR==="Tarifa Negociada"||tabActiveFR==="Negotiated Rate")?guiones:globalFunctions.numberFormat(totalCostWithTaxes, 2, '.', ',') )   }} <span class="moneda">{{currencyCode}}</span></p>
                                                            <p class="text-right ver-detalleInfoReserva">
                                                                <a class="enlaceDetalle" @click.prevent="whichRoomCode()" href="">{{$t('language.posadasCorporate.reservacionesCancelada.text21')}}</a>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </b-collapse>


                                </b-card>
                            </b-card-group>

                          <!-- agencia o compañia -->
                            <b-card-group deck>
                                <b-card header-tag="header" footer-tag="footer">

                                    <div>
                                        <p class="estancia mb-4 mt-3"
                                           v-b-toggle.agencyCompany
                                           @click="(iconoActivo == 3) ? iconoActivo = 100 : iconoActivo = 3" >
                                            <i class="icon-building"></i>
                                            {{$t('language.posadasCorporate.reservacionesCancelada.text22')}}
                                            <i class="navi icon-up" :class="(iconoActivo == 3) ? 'oculto' : ''"></i>
                                            <i class="navi icon-navigate-down" :class="(iconoActivo == 3) ? 'camposActive' : 'oculto'" ></i>
                                        </p>
                                    </div>

                                    <b-collapse id="agencyCompany" visible class="row">
                                        <div class="col-12 ">
                                            <div class="row">
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text23')}}</p>
                                                    <p class="info">{{ (nombreCompania===''||nombreCompania===null||nombreCompania===undefined?guiones:nombreCompania) }}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text24')}}</p>
                                                    <p class="info">{{clientId}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text25')}}</p>
                                                    <p class="info">{{ (cia===''||cia===null||cia===undefined?guiones:cia)}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text26')}}</p>
                                                    <p class="info">{{rfc}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text27')}}</p>
                                                    <p class="info">{{ciaAddress}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text28')}}</p>
                                                    <p class="info">{{ciaPhone}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </b-card>
                            </b-card-group>

                          <!-- metodo pago -->
                            <b-card-group deck>
                                <b-card header-tag="header" footer-tag="footer">

                                    <div>
                                        <p class="estancia mb-4 mt-3"
                                           v-b-toggle.metodoPago
                                           @click="(iconoActivo == 4) ? iconoActivo = 100 : iconoActivo = 4" >
                                            <i class="icon-currency"></i>
                                            {{$t('language.posadasCorporate.reservacionesCancelada.text29')}}
                                            <i class="navi icon-up" :class="(iconoActivo == 4) ? 'oculto' : ''"></i>
                                            <i class="navi icon-navigate-down" :class="(iconoActivo == 4) ? 'camposActive' : 'oculto'" ></i>
                                        </p>
                                    </div>

                                    <b-collapse id="metodoPago" visible class="row">
                                        <div class="col-12 ">
                                            <div class="row">
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text29')}}</p>
                                                    <p class="info">{{payment}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text30')}}</p>
                                                    <p class="info">{{(discountCode===null||discountCode===''||discountCode===undefined?guiones:discountCode)}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text31')}}</p>
                                                    <p class="info">{{promoCode===null||promoCode===''||promoCode===undefined?guiones:promoCode}}</p>
                                                </div>
                                                <div class="col-12 col-lg-3">
                                                    <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text32')}}</p>
                                                    <p class="info">{{couponNumber}}</p>
                                                </div>
                                               <div v-if="tarjeta" class="col-12 col-lg-3">
                                                <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.paymentMethods.text12')}}</p>
                                                <p class="info">{{this.cardType}}</p>
                                              </div>
                                              <div v-if="tarjeta" class="col-12 col-lg-3">
                                                <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.paymentMethods.text13')}}</p>
                                                <p class="info">{{this.cardNumber}}</p>
                                              </div>
                                              <div v-if="tarjeta" class="col-12 col-lg-3">
                                                <p class="infoResaltado mb-0">{{$t('language.posadasCorporate.paymentMethods.text19')}}</p>
                                                <p class="info">{{this.expirationDate}}</p>
                                              </div>



                                            </div>
                                        </div>
                                    </b-collapse>
                                </b-card>
                            </b-card-group>

                          <!-- politica de viaje -->
                            <b-card-group deck>
                                <b-card header-tag="header" footer-tag="footer">

                                    <div>
                                        <p class="estancia mb-4 mt-3"
                                           v-b-toggle.polViaje
                                           @click="(iconoActivo == 5) ? iconoActivo = 100 : iconoActivo = 5" >
                                            <i class="icon-travel"></i>
                                            {{$t('language.posadasCorporate.reservacionesCancelada.text33')}}
                                            <i class="navi icon-up" :class="(iconoActivo == 5) ? 'oculto' : ''"></i>
                                            <i class="navi icon-navigate-down" :class="(iconoActivo == 5) ? 'camposActive' : 'oculto'" ></i>
                                        </p>
                                    </div>

                                    <b-collapse id="polViaje" visible class="row">
                                        <div class="col-12 ">
                                            <div class="row">
                                                <div class="col-12">
                                                    <p v-if="travelPolicy !== ''" class="d-inline-block mb-0"><b class="subtitle">{{$t('language.posadasCorporate.reservacionesCancelada.text34')}}</b></p>
                                                </div>
                                                <div class="col-12">
                                                    <p class="info">
                                                       {{travelPolicy}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </b-collapse>

                                </b-card>
                            </b-card-group>

                          <!-- politica de cambio y cancelacion -->
                            <b-card-group deck>
                                <b-card header-tag="header" footer-tag="footer">

                                    <div class="col-12 row align-items-center p-0 m-0"
                                         v-b-toggle.politicasCambio
                                         @click="(iconoActivo == 1) ? iconoActivo = 100 : iconoActivo = 1" >
                                        <div class="pl-0 col-lg-8 col-11">
                                            <p class="estancia mb-3 mb-lg-4 mt-3">
                                                <i class="icon-politics"></i>
                                                {{$t('language.posadasCorporate.reservacionesCancelada.text35')}}
                                            </p>
                                        </div>
                                        <div class="col-lg-3 d-none d-lg-block pr-0">
                                          <p
                                            class="text-right mb-4 mt-3 link cursor"
                                            @click.prevent="redirectAvisoPrivacidad"
                                          >
                                            {{$t('language.posadasCorporate.reservacionConfirmacion.goOn')}}
                                            <i class="icon-report"></i>
                                          </p>
                                        </div>
                                        <div class="col-1 pr-0 pl-0">
                                            <i class="navi icon-up " :class="(iconoActivo == 1) ? 'oculto' : ''"></i>
                                            <i class="navi icon-navigate-down " :class="(iconoActivo == 1) ? 'camposActive' : 'oculto'" ></i>
                                        </div>
                                    </div>

                                    <div class="pr-0 d-lg-none d-block">
                                      <p class="mb-4 mt-3 azul" @click.prevent="redirectAvisoPrivacidad">
                                        {{$t('language.posadasCorporate.reservacionConfirmacion.goOn')}}
                                        <i class="icon-report"></i>
                                      </p>
                                    </div>

                                    <b-collapse id="politicasCambio" visible class="row" >

                                        <!-- Limite -->
                                        <div class="col-12 " v-for="(politicas, index) in HotelDetailDataPoliticas" :key="'politicas_'+index">
                                            <div class="row">
                                          
                                                <div class="col-12">
                                                    <p  class="subtitle"
                                                        :class="(iconoNaviActivo == index) ? 'camposActive' : ''"
                                                        @click="(iconoNaviActivo == index) ? iconoNaviActivo = 100 : iconoNaviActivo = index"
                                                        v-b-toggle="'togle'+index">
                                                        {{politicas.title}}
                                                        <i class="navi icon-up" :class="(iconoNaviActivo == index) ? 'camposActive' : 'oculto'"></i>
                                                        <i class="navi icon-navigate-down" :class="(iconoNaviActivo == index) ? 'oculto' : ''"></i>
                                                    </p>
                                                </div>

                                              <!-- Formulario -->
                                                <b-collapse class="col-12" v-bind:id="'togle'+index" >
                                                    <div class="row">

                                                        <div class="col-12">
                                                            
                                                             <p>{{changePolicys(politicas.description ,politicas.penaltyQuantity, guiones,tabActiveFR,ls.get('Profile').data.profileId.toLowerCase())}} </p>
                                                            
                                                        </div>
                                                    </div>
                                                </b-collapse>

                                            </div>
                                            <hr v-if="index !== HotelDetailDataPoliticas.length-1">
                                        </div>
                                    </b-collapse>
                                </b-card>
                            </b-card-group>

                          <!-- Botones -->
                            <div class="row botones mt-5">

                                <div class="col-12 col-lg-6 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
                                    <button class="button" @click="[sessionHome()]" >{{$t('language.posadasCorporate.reservacionesCancelada.text37')}}</button>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
    </div>

    <b-popover
      target="tipo-tarifa-info"
      :title="rateDescription"
      triggers="hover focus"
      placement="bottom"
      customClass="PC-popover"
      :content="benefits + ' ' + restrictions"
    ></b-popover>
    <b-popover
      target="info1"
      :title="rateDescription"
      triggers="hover focus"
      placement="bottom"
      customClass="PC-popover"
      :content="benefits + ' ' + restrictions"
    ></b-popover>
    <b-popover
    target="info"
    title=""
    triggers="hover focus"
    placement="bottom"
    customClass="PC-popover"
    :content="$t('language.posadasCorporate.reservacionConfirmacion.tootlTip')"
  ></b-popover>

    <DetalleCostos v-if="banDetCost" :key="componentKey"></DetalleCostos>
    <Footer/>
  </div>
</template>

<script>
  import Header from '../../generales/Header.vue';
  import Footer from '../../generales/Footer.vue';
  import DetalleCostos from '../DetalleCostos';
  import i18n from '../../../plugins/i18n';
  import SecureLS from 'secure-ls';
  import * as GlobalFunctions from "../../../utils/GlobalFunctions";
  import * as GlobalServices from "../../../utils/GlobalServices";

  export default {
    name: 'ReservacionesCancelada',
    components: {
      Header,
      Footer,
      DetalleCostos,
    },
    data() {
      return {
        groupBool: false,
            componentKey: 0,
banDetCost: false,
        tabActiveFR: "",
        guiones: "------",
        twoPolicy: 'igual a 2',
         twoPolicyEn: 'equal to 2',
        banSuplementMand: false,
        descriptionMA: '',
        banSuplement: false,
        supleER: '',
        banConsiEspe: false,
        considEspe: '',
        ls: new SecureLS({encodingType: 'aes'}),
        nombreCompania: '',
        numMotiva: '',
        guiones: '-------', //no cambiar este valor
        globalFunctions: GlobalFunctions,
        iconoActivo: 99,
        iconoNaviActivo: 99,
        hotelDetail:[],
        numberCancelacion:'',
        hotelName:'',
        token: '',
        buscador: false,
        language: '',
        search: '',
        code: '',
        comentario: '',
        perfiles: [],
        checkIn:'',
        checkOut:'',
        numberOfNights:'',
        roomContractTypeName:'',
        totalRooms:'',
        huespedes:'',
        totalAdults:'',
        totalChildren:'',
        totalInfants:'',
        payment:'',
        nameGuest:'',
        companion:'',
        totalCostWithTaxes:'',
        currencyCode:'',
        habitaciones:'',
        hotelMainImage:'',
        dailyRate: '',
        hotelCode:'',
        contractCode:'',
        contractTypeCode:'',
        reservationData:[],
        amenityList: [],
        cancelationNumber:'',
        hotelPhone:'',
        hotelAddress:'',
        employeeId:'',
        fiestaRewardsNumber:'',
        apreciareClubNumber:'',
        costCenter:'',
        cia:'',
        clientId:'',
        rasonSocial:'',
        rfc:'',
        ciaAddress:'',
        ciaPhone:'',
        HotelDetailDataPoliticas:[],
        travelPolicy:'',
        supplementResponse:'',
        requirementTypeResponse:'',
        benefitsAndRestrictions:'',
        rateDescription:'',
        benefits:'',
        restrictions:'',
        paymentMethod:'',
        discountCode:'',
        promoCode:'',
        couponNumber:'',
        creditCard:'',
        tarjeta:false,
        cardHolderName:'',
        cardNumber:'',
        cardType:'',
        expirationDate:'',
        average: '',
        noches:''
      }
    },
    created(){
      var ls = new SecureLS({encodingType: 'aes'});
      var grupoInfoLs = ls.get('InfoGrupo')
      this.InfoGrupo = grupoInfoLs.data
     
      var groupInfo = '';
      groupInfo = this.InfoGrupo;
      
      if(groupInfo === undefined || groupInfo === '' ){
        this.groupBool = false;
        
      }
      else{
        this.groupBool = true;
      }
      
      if(this.ls.get("descriptionMS") != null && this.ls.get("descriptionMS") != "") {
        this.descriptionMA  = this.ls.get("descriptionMS")
        this.banSuplementMand = true
      }
      if(this.ls.get("optionalSuCan") != null && this.ls.get("optionalSuCan") != "") {
        this.supleER  = this.ls.get("optionalSuCan")
        this.banSuplement = true
      }
      let hotelDetail                = ls.get("HotelDetailData").data;
      let profile                    = ls.get("Profile").data;
      let politicas                  = ls.get("HotelDetailDataPoliticas").data.response;
      let  datosHabHotSelected = ls.get("datosHabHotSelected");
       this.datosHabHotSelected = datosHabHotSelected.data;
      this.HotelDetailDataPoliticas  = politicas.ratePolicyElementResponseList;
      this.tabActiveFR = hotelDetail.roomContractTypeName
      if (hotelDetail.hotelDetailResponse.specialMessage.length > 0) {
        this.banConsiEspe = true;
        this.considEspe = hotelDetail.hotelDetailResponse.specialMessage[0];
      }
      this.average = this.ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.totalRateWithoutTaxes 
      this.noches = this.ls.get('updateCostDetail').data.hotel.nights
      this.amenityList = [];
      this.numberCancelacion      = ls.get("nomeroCancelacion");
      this.hotelName              = hotelDetail.hotelDetailResponse.hotelName;
      this.checkIn                = hotelDetail.arrivalDate;
      this.checkOut               = hotelDetail.departureDate;
      this.hotelPhone             = hotelDetail.hotelDetailResponse.hotelPhone;
      this.hotelAddress           = hotelDetail.hotelDetailResponse.hotelAddress;
      this.employeeId             = hotelDetail.employeeNumber;
      this.nameGuest              = hotelDetail.name + ' ' + hotelDetail.fatherSurname + ' ' + hotelDetail.motherSurname;
      this.companion              =this.ifNull(hotelDetail.companionName) + ' ' + this.ifNull(hotelDetail.companionFatherSurname) + ' ' + this.ifNull(hotelDetail.companionMotherSurname);
      this.numberOfNights         = this.getTextNights(hotelDetail.numberOfNights);
      this.habitaciones           = this.getHabitaciones(hotelDetail);
      this.totalRooms             = this.getTotalRooms(hotelDetail.totalRooms);
      this.huespedes              = this.getHuesped(hotelDetail);
      this.totalAdults            = this.getTotalAdults(hotelDetail.totalAdults);
      this.totalChildren          = this.getTotalChildren(hotelDetail.totalChildren);
      this.totalInfants           = this.getTotalInfants(hotelDetail.totalInfants);
      this.payment                = this.getPaymentType(hotelDetail.paymentResponse);
      this.travelPolicy           = hotelDetail.travelPolicy;
      this.roomContractTypeName   = hotelDetail.roomContractTypeName;
      this.fiestaRewardsNumber    = (hotelDetail.fiestaRewardsNumber === '' || hotelDetail.fiestaRewardsNumber === null )?this.guiones:hotelDetail.fiestaRewardsNumber;
      this.apreciareClubNumber    = (hotelDetail.apreciareClubNumber === '' || hotelDetail.apreciareClubNumber === null )?this.guiones:hotelDetail.apreciareClubNumber;
      this.costCenter             = (hotelDetail.costCenter === '' || hotelDetail.costCenter === null )?this.guiones:hotelDetail.costCenter;
      this.cia                    = (hotelDetail.socialReasonResponse.agencyName === '' || hotelDetail.socialReasonResponse.agencyName=== null )?this.guiones:hotelDetail.socialReasonResponse.agencyName;
      this.clientId               = profile.profileId;
      GlobalServices._consultaProfileById(this.ls.get('Token').data, this.ls.get('Language').data, this.clientId).then(response => {
        this.nombreCompania = response.data.genericName;
      });
      this.rasonSocial            = (hotelDetail.socialReasonResponse.agencyType === '' || hotelDetail.socialReasonResponse.agencyType=== null )?this.guiones:hotelDetail.socialReasonResponse.agencyType;
      this.rfc                    = (hotelDetail.socialReasonResponse.agencyRFC === '' || hotelDetail.socialReasonResponse.agencyRFC=== null )?this.guiones:hotelDetail.socialReasonResponse.agencyRFC;
      this.ciaAddress             = (hotelDetail.socialReasonResponse.agencyAddress === '' || hotelDetail.socialReasonResponse.agencyAddress=== null )?this.guiones:hotelDetail.socialReasonResponse.agencyAddress;
      this.ciaPhone               = (hotelDetail.socialReasonResponse.agencyPhone === '' || hotelDetail.socialReasonResponse.agencyPhone=== null )?this.guiones:hotelDetail.socialReasonResponse.agencyPhone;
      this.supplementResponse     = hotelDetail.supplementResponse;
      this.requirementTypeResponse = (hotelDetail.requirementTypeResponse === '' || hotelDetail.requirementTypeResponse === null )?this.guiones:hotelDetail.requirementTypeResponse;
      this.totalCostWithTaxes     = hotelDetail.ratesResponse.totalCost //WithTaxes;
      this.currencyCode           = hotelDetail.currencyCode;
      this.hotelMainImage         = hotelDetail.hotelDetailResponse.hotelMainImage;
      this.srcMaps = process.env.VUE_APP_APIMAPS + hotelDetail.hotelDetailResponse.hotelLatitude + ',' + hotelDetail.hotelDetailResponse.hotelLongitude + '&hl=es;z=14';
      this.rateDescription        = (hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList.length==0?'':hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList[0].rateDescription);
      this.benefits               = (hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList.length==0?'':hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList[0].benefits);
      this.restrictions           = (hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList.length==0?'':hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList[0].restrictions);
      this.benefitsAndRestrictions = ((this.benefits === '' && this.benefits === null) && (this.restrictions === '' && this.restrictions === null))?this.guiones:this.benefits + ' ' + this.restrictions
      this.discountCode = (hotelDetail.discountCode==''||hotelDetail.discountCode==null||hotelDetail.discountCode==undefined?hotelDetail.promoCode:hotelDetail.discountCode);
      this.promoCode = hotelDetail.roomContractTextName;
      this.couponNumber           = (hotelDetail.couponNumber === '' || hotelDetail.couponNumber === null )?this.guiones:hotelDetail.couponNumber;
      this.numMotiva = hotelDetail.motivaNumber;
      this.creditCard             = this.setCreditcart(hotelDetail.paymentResponse.creditCard.cardNumber);
      for(var i = 0; i < hotelDetail.hotelDetailResponse.amenityList.length; i++) {
        this.amenityList.push({
          amenityName: hotelDetail.hotelDetailResponse.amenityList[i].amenityName,
          amenityIcon: hotelDetail.hotelDetailResponse.amenityList[i].amenityIcon
        });
      }
    },
    methods:{
       changePolicys(policyDesc, rate,guiones,rateActive,tCliente){ 
      //KB48764 m.a.cortes  
      if(policyDesc.includes(this.twoPolicy) ||  policyDesc.includes(this.twoPolicyEn)){         
        let rateUltimateTwo = this.average/this.noches;
        var twonoches= rateUltimateTwo*2;
        twonoches = twonoches.toFixed(2);  
        policyDesc= policyDesc.replace(rate,`$${twonoches.toLocaleString('en')}`);  
       }else{      
          let rateUltimate = this.average/this.noches;    
          rateUltimate = rateUltimate.toFixed(2);         
          policyDesc= policyDesc.replace(rate,`$${rateUltimate.toLocaleString('en')}`);
       }        
      if(tCliente=='PYP'||tCliente=='PYPSA'){
         if(rateActive==1){
          policyDesc=policyDesc.replace(rate,guiones);
              }
          policyDesc=policyDesc;
          return policyDesc;
            }
       return policyDesc;
	  },
      redirectAvisoPrivacidad() {
        (this.ls.get('Language').data=='es'?window.open(process.env.VUE_APP_POLICIES, '_blank'):window.open(process.env.VUE_APP_POLICIESEN, '_blank'));
      },
      ifNull(data){
        if(data === null){
          return "";
        }
        return data;
      },
      setCreditcart(creditCardNumber){
        let hiddenNumber =  creditCardNumber.substr(12);
        let asteriks = "**** **** **** ";
        let hiddenCode = asteriks.concat(hiddenNumber);
        return hiddenCode;
      },
      whichRoomCode() {
        this.componentKey += 1;
 this.banDetCost = true;
        // PYP Validation
        let datosHabHotModalCosto = null
        datosHabHotModalCosto = this.ls.get('updateCostDetail').data
        if(this.ls.get('Profile').data.profileId.toLowerCase()=="pyp"||this.ls.get('Profile').data.profileId.toLowerCase()=="pypsa") {
              datosHabHotModalCosto.userClientID = this.ls.get('Profile').data.profileId
        }
        if(datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == "Tarifa Negociada" || datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == "Negotiated Rate") {
           datosHabHotModalCosto.tabActive  = 1
        }
        this.ls.set('updateCostDetail', {data: datosHabHotModalCosto})
        // PYP Validation
        setTimeout(() => {
         this.$bvModal.show('detalleDeCosto1');
       }, 5);
        return;
        this.componentKey += 1;
        var availibilityRequest = this.ls.get('availibilityRequest').data;
        this.banDetCost = true;
        this.datosHabHotModalCosto.localStor = 'datosHabHotSelected';
        this.datosHabHotModalCosto.hotel = room;

        if(this.tabActive == 1) {
          this.datosHabHotModalCosto.whichRates = 'Negociadas';

        }
        if(this.tabActive == 2) {
          this.datosHabHotModalCosto.whichRates = 'Publicas';

        }

        if(this.$store.getters.gettingLang == 'es' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Public Rate') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Tarifa Pública'
        }
        if(this.$store.getters.gettingLang == 'en' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Tarifa Pública') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Public Rate'
        }

        if(this.$store.getters.gettingLang == 'es' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Negotiated Rate') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Tarifa Negociada'
        }
        if(this.$store.getters.gettingLang == 'en' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Tarifa Negociada') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Negotiated Rate'
        }

        this.datosHabHotModalCosto.habitacion = availibilityRequest;
      this.ls.set('updateCostDetail', {data: this.datosHabHotModalCosto})
        this.banModDetCosto = true;
        setTimeout(() => {
          this.$bvModal.show('detalleDeCosto1');
        }, 5);
        this.idxDetailCosto = index;
        this.roomCodeForTextTooltip = roomCode
      },
      sessionHome() {
        if(!this.groupBool){
        GlobalFunctions.cleanLocalStorageOfReserva();
        var picked = '';
        if(this.$store.getters.gettingLang == 'es') {
          picked = 'MXN'
        } else {
          picked = 'USD'
        }
        // Reservaciones
        var availibilityRequest = {
          hotelName: '',
          hotelCode: '',
          arrivalDate: '',
          departureDate: '',
          currencyCode: picked,
          totalAdults: 1,
          totalChildren: 0,
          totalInfants: 0,
          totalRooms: 1,
          agreementCode: '',
          iataCode: '',
          motivaCode: '',
          discountCode: '',
          promoCode: '',
          profileType: '',
          roomCodeList: [],
          selectedRooms: [],
          beautiDateInput:   '',
          beautiDateOutput:   ''
        }
        var ls = new SecureLS({encodingType: 'aes'});
        ls.set('availibilityRequest', {data: availibilityRequest});
        ls.set('specialMessageR',{data: 'N/A'})
        this.clearHomeCounter++
        ls.set('clearHome', {data: this.clearHomeCounter})
        this.$store.commit('gettingClearHome')
        this.$router.push({ name: 'Reservaciones'})
      }
      this.$router.push({ name: 'Reservaciones'})
      },
      getHabitaciones(response){
        let habitaciones = '';
        let data1 = '';
        let data2 = '';
        let roomCode = response.roomCode;
        let roomCodes = response.hotelDetailResponse.roomDetailResponseList;
        roomCodes.forEach(function(value){
          habitaciones = "";
          if(value.roomCode === roomCode){
            data1 = value.roomName;
          }else {
            data2 = i18n.t('language.posadasCorporate.reservacionCancelacion.noEncontrado');
          }
        });

        if(data1 !== ''){
          habitaciones = data1;
        }else{
          habitaciones = data2;
        }
        return habitaciones;
      },
      getHuesped(response){
        let huespedes = response.totalAdults + response.totalChildren + response.totalInfants;
        let huesped =  "";
        if(huespedes > 1){
          huesped = " " + huespedes + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.huespedes');
        }else if(huespedes === 1){
          huesped = " " + huespedes + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.huesped');
        }
        return huesped;
      },
      getTotalAdults(totalAdults){
        let totalAdult = "";
        if(totalAdults > 1){
          totalAdult = " " + totalAdults + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.adultos');
        }else if(totalAdults === 1){
          totalAdult = " " + totalAdults + "  " +i18n.t('language.posadasCorporate.reservacionCancelacion.adulto');
        }
        return totalAdult;
      },
      getTotalChildren(totalChildrens){
        let totalChildren = "";
        if(totalChildrens > 1){
          totalChildren = ", " + totalChildrens + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.menores');
        }else if(totalChildrens === 1){
          totalChildren = ", " + totalChildrens + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.menor');
        }
        return totalChildren;
      },
      getTotalInfants(totalInfants){
        let totalInfant = "";
        if(totalInfants > 1){
          totalInfant = " y " + totalInfants + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.infantes');
        }else if(totalInfants === 1) {
          totalInfant = " y " + totalInfants + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.infante');
        }
        return totalInfant;
      },
      getTotalRooms(totalRooms){
        let totalRoom = 0;
        if(totalRooms > 1){
          totalRoom = " " + totalRooms + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.habitaciones');
        }else if(totalRooms === 1) {
          totalRoom = " " + totalRooms + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.habitacion');
        }
        return totalRoom;
      },
      getCompanionName(a, b, c){
        let companionName = '';
        if(a === null)
          return '————————';

        return a + ' ' + b + ' ' + c==null? '':c;
      },
      getTextNights(numNights){
        let numberNights = 0;
        if(numNights > 1){
          numberNights = " " + numNights + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.noches');
        }else if(numNights === 1) {
          numberNights = " " + numNights + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.noche');
        }
        return numberNights;
      },
      currency(amount) {
        return Number(amount).toLocaleString(undefined, {maximumFractionDigits: 2}) || '0';
      },
      getPaymentType(paymentResponse){
        let value = '';
        if(paymentResponse.voucher != null){
          value = paymentResponse.voucher.voucherNumber;
        }
        if(paymentResponse.creditCard != null){
          this.tarjeta = true;
          value = paymentResponse.paymentMethod;
          this.cardHolderName= paymentResponse.creditCard.cardHolderName;
          this.cardNumber= this.setCreditcart(paymentResponse.creditCard.cardNumber);
          this.cardType= paymentResponse.creditCard.cardType;
          this.expirationDate= paymentResponse.creditCard.expirationDate;
        }
        return value;
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/config.scss';
  .contentContacto {
    display: flex;
    position: relative;
    min-height: 70vh;
  }
  i:before {
    margin-left: 0px !important;
  }
  i {
    font-size: 24px;
  }
  .navi {
    float: right;
    font-size: 20px !important;
  }
  .camposActive {
    color: #0c5458;
    font-weight: 500;
  }
  .card-deck:first-child {
    .card {
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .card-deck:nth-child(n+2) {
    .card {
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      border-top: none;
    }
  }
  .card-deck:last-child {
    .card {
      border-bottom-left-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }
  }
  .contacto {
    width: 100%;
    margin-top: 57px;
    padding-top: 32px;
    .card-body {
      min-height: 10px;
      .card-title {
        font-size: $font-size-large;
      }
    }
    .estancia {
      font-size: $font-size-biglarge;
      font-weight: bold;
    }
  }
  .cancelarReserva {
    .card-header {
      background-color: #f8d7da;
      color: #9d1b24;
    }
    .referencia {
      color: $colorBase2;
    }
  }
  .enlacesContacto {
    color: $colorBase2;
    font-weight: 500;
    .demo-icon {
      font-size: $font-size-biglarge;
    }
  }
  .infoResaltado {
    font-size: 14px;
    font-weight: 500;
  }
  .info {
    font-size: 14px;
  }
  .cardInfoRegistro {
    position: fixed;
    max-width: 290px;
  }
  .tituloInfo {
    font-size: 15px;
    font-weight: bold;
  }
  .parrafoInfo {
    font-size: 14px;
    font-weight: 500;
  }
  .infoHabitacion {
    font-size: 14px;
    font-weight: normal;
  }
  .notasInfoReserva {
    font-size: 12px;
    color: #777777;
  }
  .demo-icon {
    font-size: 18px;
  }
  .icon-info {
    font-size: 20px;
    color: #005a83;
  }
  .moneda {
    font-size: 12px;
    font-weight: 500;
  }
  .azul {
    color: #005a83;
    font-weight: 500;
  }
  .enlaceDetalle {
    font-size: 14px;
    font-weight: 500;
    color: #005a83;
  }
  .costosTable{
    width: 50%;
    display: inline-block;
    padding-bottom: 10px;
  }
  @media only screen and (max-width: 736px){
    .costosTable{
      width: 100%;
      display: inline-block;
    }
  }
  .botonesInfo {
    left: 50%;
  }
  @media only screen and (max-width: 992px) {
    .botonesInfo {
      left: 0;
    }
    .card-deck .card {
      margin-bottom: 0px;
    }
  }
</style>
